import { useLocation } from "react-router-dom";
import { useSiteMargin } from "./useSiteMargin";

// The standalone branded screens own the full width — sign-in, the
// password-reset pair, accept-invitation, and the Shopify popup — so they get no
// gutter at all.
const FULL_BLEED_PATHS = new Set([
  "/sign-in",
  "/create-account",
  "/request-reset-password",
  "/reset-password",
  "/accept-invitation",
  "/connect-shopify",
]);

/**
 * The gutter down each side of the app, in px.
 *
 * Both the nav bar and the routed content read this, which is the whole point:
 * the nav used a fixed `px-8` while the body used this measured value, so the
 * logo never lined up with the page heading beneath it and the two right edges
 * disagreed too. One source, one alignment — including the full-bleed screens,
 * where nav and body both go to zero rather than only the body.
 */
export function useAppSiteMargin(): number {
  const measured = useSiteMargin();
  const location = useLocation();
  return FULL_BLEED_PATHS.has(location.pathname) ? 0 : measured;
}
